import React from "react";

export default function Progress(props: { progress: number }) {
  return (
    <div
      style={{ height: 5.5, backgroundColor: "rgba(244, 244, 244, 1)" ,marginBottom:20,marginTop:5}}
      className="progress"
      role="progressbar"
      aria-label="Basic example"
      aria-valuenow={props.progress as any}
      aria-valuemin={"0" as any}
      aria-valuemax={"100" as any}
    >
      <div
        className="progress-bar"
        style={{ width: props.progress + "%", backgroundColor: "rgba(17, 17, 17, 1)" }}
      ></div>
    </div>
  );
}
